import * as React from 'react';
export const giftSvg = React.forwardRef(function giftSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.125 10.875V12h-8.25v-1.125h8.25Zm.75-.75v-4.5a.75.75 0 0 0-.75-.75h-8.25a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75V12A1.875 1.875 0 0 1 0 10.125v-4.5C0 4.589.84 3.75 1.875 3.75h8.25c1.036 0 1.875.84 1.875 1.875v4.5C12 11.161 11.16 12 10.125 12v-1.125a.75.75 0 0 0 .75-.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.438 11.25V4.5a.563.563 0 0 1 1.125 0v6.75a.562.562 0 1 1-1.125 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.25 7.313a.562.562 0 1 1 0 1.125H.75a.563.563 0 0 1 0-1.126h10.5Zm-1.125-5.25a.952.952 0 0 0-.938-.938c-.607 0-1.26.323-1.774.91a3.467 3.467 0 0 0-.8 1.696c.873-.049 1.714-.198 2.363-.461.819-.333 1.149-.753 1.149-1.207Zm1.125 0c0 1.154-.889 1.86-1.85 2.25-.982.398-2.234.562-3.4.562a.563.563 0 0 1-.563-.562 4.6 4.6 0 0 1 1.13-3.02C7.244.521 8.186 0 9.187 0c1.128 0 2.063.935 2.063 2.063Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.813 0c1.001 0 1.943.52 2.62 1.293a4.6 4.6 0 0 1 1.13 3.02c0 .31-.252.562-.563.562-1.166 0-2.418-.164-3.4-.563C1.64 3.922.75 3.218.75 2.063.75.935 1.685 0 2.813 0Zm-.938 2.063c0 .454.33.874 1.15 1.207.648.263 1.489.412 2.362.46a3.466 3.466 0 0 0-.8-1.695c-.515-.587-1.167-.91-1.774-.91a.952.952 0 0 0-.938.938Z',
    }),
  );
});
giftSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var gift = {
  category: 'icon',
  colorable: true,
  name: 'gift',
  svg: giftSvg,
};
